import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { LoginService } from '../login.service';
import { LogService } from '../log.service';
//import { AppComponent } from '../app.component';

@Component({
  selector: 'qst-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  loginError: string;

  constructor( 
    private router: Router,
    private loginService: LoginService,
    private log: LogService ) { }

  ngOnInit(): void {
  }

  onSubmit(loginForm) {
    this.log.trace("LoginComponent.onSubmit()");
    this.log.debug(loginForm);

    // Validate game code, then give error or proceede to game.


    // do we need a .subscribe here?
    //this.router.navigateByUrl( '/loading' );
    this.loginService.login(loginForm.TeamCode.toUpperCase());
  }

  loginFail() {
    this.log.trace("LoginComponent.loginFail()");

    // We can set this on success or failure, it is not displayed on success.
    this.loginError = this.loginService.getError();
    return this.loginService.loginFail();
  }

  loginWarn() {
    this.loginError = this.loginService.getError();
    return this.loginService.loginWarn();
  }
}
